import React, { useContext, useState, useCallback, useEffect } from "react";
import AuthContext from "../../context/AuthContext";
import Paginator from "../paginator/Paginator";
import {
  getServicioService,
  createServicioService,
  updateServicioService,
  deleteServicioService,
} from "../../utils/ServicioService";
import CreateServicioModal from "./CreateServicioModal";
import EditServicioModal from "./EditServicioModal";
import DeleteButton from "./DeleteServicioButton";
import Loading from "../loading/Loading";

function TablaServicios() {
  const { authTokens } = useContext(AuthContext);
  const [servicios, setServicios] = useState([]);
  const [displayServicios, setDisplayServicios] = useState([]);

  // States de la barra de busqueda.
  const [busqueda, setBusqueda] = useState("");
  const [busquedaResult, setBusquedaResult] = useState([]);

  // State Loading
  const [loading, setLoading] = useState(true);

  // Funciones encargadas de pedir info a la db.
  const getServicios = useCallback(async () => {
    const servicios = await getServicioService(authTokens);
    setServicios(servicios ?? []);
    setLoading(false);
  }, [authTokens]);

  

  const updateServicio = useCallback(async (id, servicio) => {
    updateServicioService(id, servicio, authTokens).then((response) => {
      const aux = servicios.map((serv) => (serv.id === id ? response : serv));
      setServicios(aux);
    });
  });

  const deleteServicio = useCallback(
    async (id) => {
      await deleteServicioService(id, authTokens);
      const aux = servicios.filter((servicio) => servicio.id !== id);
      setServicios(aux);
      setBusqueda("");
    },
    [authTokens, servicios]
  );

  useEffect(() => {
    getServicios();
  }, []);

  // Cada vez que 'busqueda' cambie, corremos search()
  useEffect(() => {
    search();
  }, [busqueda]);

  // Funcion que maneja el cambio en el campo de busqueda de clientes
  // Funcion que maneja el cambio en el campo de busqueda de productos
  const handleSearchChange = (search) => {
    setBusqueda(search);
  };

  // Funcion que maneja la busqueda
  const search = () => {
    // Si se escribio algo en busqueda filtramos sobre todos los servicios
    let aux = servicios.filter((servicio) =>
      getFullName(servicio).includes(busqueda.toLocaleLowerCase())
    );
    setBusquedaResult(aux);
  };

  const getFullName = (servicio) => {
    return servicio.servicio.toLowerCase();
  };

  return (
    <div>
      <div className="row">
        <div className="mt-4  d-flex justify-content-start">
          {" "}
          <h4>Servicios</h4>{" "}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 py-4 col-sm-12 d-flex justify-content-start">
          <CreateServicioModal servicios={servicios} setServicios={ setServicios }/>
        </div>
        <div className="col-lg-10 col-sm-12">
          <div className="input-group input-group-sm my-4">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar servicios."
              value={busqueda}
              onChange={(e) => {
                handleSearchChange(e.target.value);
              }}
            />
            <div className="input-group-append">
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={() => setBusqueda("")}
                type="button"
              >
                {busqueda ? "Borrar" : "Buscar"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {!loading ? (
        <>
          <div className="table-responsive">
            <table className="table table-sm table-hover table-dark">
              <caption>Listado de Servicios</caption>
              <thead>
                <tr>
                  <th className="col-lg-4">Servicio</th>
                  <th className="col-1">Corto</th>
                  <th className="col-1">C/Tarjeta</th>
                  <th className="col-1">Medio</th>
                  <th className="col-1">M/Tarjeta</th>
                  <th className="col-1">Largo</th>
                  <th className="col-1">L/Tarjeta</th>
                  <th className="col-lg-2">Accion</th>
                </tr>
              </thead>
              <tbody>
                {busqueda.length > 0
                  ? busquedaResult.map((servicio) => {
                      return (
                        <tr key={servicio.id} className="table-light ">
                          <td>{servicio.servicio}</td>
                          <td>${servicio.prC}</td>
                          <td>${servicio.prCT}</td>
                          <td>${servicio.prSL}</td>
                          <td>${servicio.prSLT}</td>
                          <td>${servicio.prL}</td>
                          <td>${servicio.prLT}</td>
                          <td>
                            <EditServicioModal
                              servicioEditando={servicio}
                              updateServicio={updateServicio}
                            />
                            <DeleteButton
                              id={servicio.id}
                              deleteServicio={deleteServicio}
                              setServicios={setServicios}
                            />
                          </td>
                        </tr>
                      );
                    })
                  : displayServicios.map((servicio) => {
                      return (
                        <tr key={servicio.id} className="table-light ">
                          <td>{servicio.servicio}</td>
                          <td>${servicio.prC}</td>
                          <td>${servicio.prCT}</td>
                          <td>${servicio.prSL}</td>
                          <td>${servicio.prSLT}</td>
                          <td>${servicio.prL}</td>
                          <td>${servicio.prLT}</td>
                          <td>
                            <EditServicioModal
                              servicioEditando={servicio}
                              updateServicio={updateServicio}
                            />
                            <DeleteButton
                              id={servicio.id}
                              deleteServicio={deleteServicio}
                              setServicios={setServicios}
                            />
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
          <br />
          <Paginator items={servicios} setDisplayItems={setDisplayServicios} />
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
}

export default TablaServicios;
